<template>
  <div class="search-field">
    <transition name="from-right">
      <div
        v-show="isOpen"
        class="search-wrapper"
        :class="{ 'collapsed': !isOpen }"
      >
        <label class="search-label" for="search"></label>
        <input
          id="search"
          ref="searchText"
          v-model.trim="searchText"
          type="text"
          :title="$t('search.by.transactions')"
          :placeholder="$t('common.search')"
          class="search-input"
          maxlength="64"
          spellcheck="false"
          autocomplete="off"
          @focus="$emit('toggle-block')"
          @blur="$emit('toggle-block')"
        />
      </div>
    </transition>
    <button
      class="search-button"
      :class="{ 'collapsed': isOpen }"
      @click.prevent="toggleSearch"
    ></button>
  </div>
</template>

<script>
import throttle from 'lib/utils/throttle';

const AMOUNT_REG_EXP = /^-\d+/;

export default {
  name: 'SearchField',
  mounted() {
    if (!this.$route.query.public_id) {
      return;
    }

    this.searchText = this.$route.query.public_id;
    this.isOpen = true;
  },
  data() {
    return {
      searchText: '',
      isOpen: false,
    };
  },
  computed: {
    preparedSearchText() {
      if (AMOUNT_REG_EXP.test(this.searchText)) {
        return this.searchText.replace(/^-/, '');
      }

      return this.searchText;
    },
  },
  watch: {
    searchText() {
      this.processSearching();
    },
  },
  methods: {
    toggleSearch() {
      if (this.isOpen) {
        this.searchText = '';
      } else {
        setTimeout(() => {
          this.$refs.searchText.focus();
        }, 500);
      }

      this.isOpen = !this.isOpen;
    },
    // eslint-disable-next-line prefer-arrow-callback
    processSearching: throttle(function () {
      this.$emit('process', this.preparedSearchText);
    }, 500),
  },
};
</script>

<style lang="sass" scoped>
  .from-right-enter-active, .from-right-leave-active
    transition: all .3s ease

  .from-right-enter, .from-right-leave-to
    transform: translateX(200px)
    opacity: 0

  .search-field
    position: relative

  .search-wrapper
    display: flex
    padding: 0 20px

    #{theme("eclipse")} &
      background-color: #F5F5F5

    #{theme("obsidian")} &
      background-color: #1D1D2F

  .search-input
    margin: 0 34px 0 20px

    #{theme("eclipse")} &
      color: #212121

    #{theme("obsidian")} &
      color: $pure-white

  .search-label
    width: 34px
    height: 34px
    background-color: transparent
    background-repeat: no-repeat
    background-position: center
    background-size: 22px
    cursor: pointer

    #{theme("eclipse")} &
      background-image: get-icon("search", #212121)

    #{theme("obsidian")} &
      background-image: get-icon("search", $pure-white)

  .search-button
    width: 34px
    height: 34px
    position: absolute
    top: 0
    right: 20px
    background-color: transparent
    background-repeat: no-repeat
    background-position: center
    background-size: 22px
    cursor: pointer

    #{theme("eclipse")} &
      background-image: get-icon("search", #212121)

    #{theme("obsidian")} &
      background-image: get-icon("search", $pure-white)

    &:hover
      background-image: get-icon("search", #999999)

    &.collapsed

      #{theme("eclipse")} &
        background-image: get-icon("x", #212121)

      #{theme("obsidian")} &
        background-image: get-icon("x", $pure-white)

      &:hover
        background-image: get-icon("x", #999999)

</style>
